import { Loadable } from 'components/common';
import React, { useEffect, useRef } from 'react';
import { ChatSessionDto } from 'types';
import { useDivWidth } from 'utils/layout';
import { OmniHistoriesProvider } from 'contexts';
import AIAgentChat from './AIAgentChat';
import { useAIAgentCenterContext } from 'contexts/ai-agent-center';
import {
  onReceiveChatSessionAIInProgress,
  onReceiveChatSessionInProgress,
  onRemoveChatSessionAIInProgress,
  onRemoveChatSessionInProgress
} from 'services';

type Props = {
  isIntervention: boolean;
};
const AIAgentChatBox: React.FC<Props> = ({ isIntervention }) => {
  const ref = useRef<HTMLDivElement>(null);
  const chatBoxWidth = useDivWidth(ref);
  const { chatSession, setChatSession } = useAIAgentCenterContext();

  useEffect(() => {
    onReceiveChatSessionAIInProgress((data: ChatSessionDto) => {
      if (data.chatSessionId === chatSession?.chatSessionId) {
        setChatSession(data);
      }
    });

    onRemoveChatSessionInProgress((data: ChatSessionDto) => {
      if (data.chatSessionId === chatSession?.chatSessionId) {
        setChatSession(data);
      }
    });
  }, [chatSession?.chatSessionId]);

  if (!chatSession) return null;
  return (
    <div ref={ref}>
      {chatBoxWidth > 0 && (
        <Loadable>
          <OmniHistoriesProvider
            key={chatSession.chatSessionId + chatSession.chatId + chatBoxWidth}
            isRead={false}
            endpointName={'history-chat-sessions'}
            chatSession={chatSession}
            variables={{
              systemMessText: '#ffff'
            }}
            isShowName={false}
            chatBoxWidth={chatBoxWidth * 0.7}
            setChatSession={setChatSession}
          >
            <AIAgentChat chatSession={chatSession} isIntervention={isIntervention} />
          </OmniHistoriesProvider>
        </Loadable>
      )}
    </div>
  );
};
export default AIAgentChatBox;
